import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const BULK_EDIT_CREATIVES = 'bulkEditCreatives';

export const useBulkEditCreativeIds = queryParamHookFactory(BULK_EDIT_CREATIVES);
